const Library = {
  LIBRARY_DO_EXPORT: 'Librairy/export',
}

export default Library;
